import { dehydrate, QueryClient } from '@tanstack/react-query';
import React from 'react';

import SectionTitle from '@/components/Core/SectionTitle/SectionTitle';
import MainLayout from '@/components/Layout/Main';
import { CustomMeta } from '@/components/Meta/CustomMeta';
import Button from '@/components/Primitive/Button/Button';
import useQuery, { makeQuery } from '@/hooks/use-query';
import {
  createUserAgreementQuery,
  mapToUserAgreementContent,
} from '@/queries/globals/user-agreement';

const userAgreementPageQuery = createUserAgreementQuery();
const userAgreementVars = {};

const ContactPage = () => {
  const { data } = useQuery(
    userAgreementPageQuery,
    userAgreementVars,
    mapToUserAgreementContent
  );

  const { archive } = data || {};
  return (
    <MainLayout withNavSpacer>
      <CustomMeta {...data?.seo} />
      <div className="pb-page space-y-page mx-auto w-full overflow-hidden">
        <div className="container-lg space-y-8 md:space-y-12">
          <SectionTitle className="pt-3" title="User Agreement" />
          <div className="space-y-8 md:space-y-12">
            {archive?.map(({ id, description, title, version }) => (
              <div key={id} className="space-y-1 text-center">
                <h2 className="text-center text-2xl text-cream md:text-3xl">
                  {title}
                </h2>
                <p className="text-center text-grayAlt-500">{description}</p>
                <div className="flex flex-col items-center justify-center space-y-3 pt-5">
                  {version.map((v) => (
                    <Button
                      className="min-w-[250px] uppercase"
                      href={v.downloadUrl}
                      target="_blank"
                      key={v.title}
                    >
                      {v.title}
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactPage;

export async function getStaticProps() {
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery(
    ['query', userAgreementPageQuery, userAgreementVars],
    async () => {
      return makeQuery(
        userAgreementPageQuery,
        userAgreementVars,
        mapToUserAgreementContent
      );
    }
  );

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60,
  };
}
